// @flow
import React from 'react';
import { formatFullDate } from 'utils/dateUtils';
import { getDateFromString } from 'utils/dateUtils';
import { Link } from 'react-router-dom';

type Props = {
  img: string,
  title: string,
  date: Date | string,
  description: string,
  url: string,
  caption?: string
};

const NewsListElement = (props: Props) => {
  const date = getDateFromString(props.date);
  return (
    <Link to={props.url} className="news news--list ">
      <article>
        <div className="news--list__left">
          <div className="news__thumbnail img-blue" style={{ backgroundImage: `url(${props.img})` }} />
          {!!props.caption && <p className="news__desc">{props.caption}</p>}
        </div>
        <div className="news__content">
          <p className="news__title ft-h3">{props.title}</p>
          <p className="ft-h6 news__date">{formatFullDate(date)}</p>
          <p className="news__desc">{props.description}</p>
        </div>
      </article>
    </Link>
  );
};

export default NewsListElement;
